import FormInputTypes from '../components/atoms/formEnums/formInputTypes';
import { IconType } from '../components/atoms/icon/icon';

export default {
  title: 'Override Extended Info Visualization',
  attributeName: 'tags-extended',

  fields: [
    
    {
      attributeName: 'button-copy',
      label: 'Copy Styles from Poster',
      buttonText:'Copy Poster info',
      handler:'copyPosterValues',
      helpText:'Copy the values from poster',
      type: FormInputTypes.BUTTON,
      enabledWhen:{"field":"locked","values":[0]},
      visibleWhen: [{"field":"type","value":"content"}]

    },
    {
      attributeName: 'extendedInfoTagMode',
      helpText: 'Select how the tag is going to be shown',
      type: FormInputTypes.SELECT,
      label: 'Tag Mode',
      placeholder: 'Tag Mode...',
      emptyValue:true,
      default:'(Empty)', //default value to empty option      
      options: [
        { name: 'Custom Design', value: 'text'},
        { name: 'Upload Image', value: 'image' },
      ],
      enabledWhen:{"field":"locked","values":[0]},
      visibleWhen: [{"field":"type","value":"content"}]
    },
    {
      attributeName: 'extendedInfoLabel',
      helpText: 'Label of the tag',
      type: FormInputTypes.TEXT_INPUT.TEXT,
      label: 'Label',
      placeholder: 'Label...',
      enabledWhen:{"field":"locked","values":[0]},
      visibleWhen: [{"field":"extendedInfoTagMode","value":"text"},{"field":"type","value":"content"}]
    },
    {
      attributeName: 'extendedInfoWidth',
      helpText: 'Select Fixed width for long tags specially for poster tags, and inline for short tags or tags you need to be as big as the tag is',
      type: FormInputTypes.SELECT,
      label: 'Width',
      placeholder: 'Width...',
      options: [
        { name: 'Fixed width', value: 'fixed'},
        { name: 'Inline', value: 'inline' },
      ],
      enabledWhen:{"field":"locked","values":[0]},
      visibleWhen: [{"field":"extendedInfoTagMode","value":"text"},{"field":"type","value":"content"}]
    },
    {
      attributeName: 'extendedInfoFont',
      helpText: 'Font family of the tag',
      type: FormInputTypes.SELECT,
      label: 'Font',
      placeholder: 'Font...',
      options: [
        { name: 'BT Brik', value: 'bt-brik'},
        { name: 'Montserrat', value: 'montserrat' },
        
      ],
      enabledWhen:{"field":"locked","values":[0]},
      visibleWhen: [{"field":"extendedInfoTagMode","value":"text"},{"field":"type","value":"content"},{ "field": "typeTagName", "notValue": "Logo", "allowUndefined": true }]
    },
    {
      attributeName: 'extendedInfoIconId',
      type: FormInputTypes.DOWNLOADABLE,
      label: 'Icon',
      helpText: 'Icon of the tag.',
      placeholder: 'Icon...',
      fileType: ['image/*'],
      canUpdate:false,
      hasSelect:false,
      enabledWhen:{"field":"locked","values":[0]},
      visibleWhen: [{"field":"extendedInfoTagMode","value":"text"},{"field":"type","value":"content"},{ "field": "typeTagName", "notValue": "Logo", "allowUndefined": true }]
    },
    {
      attributeName: 'extendedInfoIconId',
      type: FormInputTypes.DOWNLOADABLE,
      label: 'Image',
      helpText: 'Image of the tag.',
      placeholder: 'Image...',
      fileType: ['image/*'],
      canUpdate:false,
      hasSelect:false,
      enabledWhen:{"field":"locked","values":[0]},
      visibleWhen: [{"field":"extendedInfoTagMode","value":"image"},{"field":"type","value":"content"},{ "field": "typeTagName", "notValue": "Logo", "allowUndefined": true }]
    },
  
    {
      attributeName: 'extendedInfoTextColor',
      type: FormInputTypes.COLOR_PICKER,
      label: 'Text Color',
      helpText: 'Text color of the tag',
      enabledWhen:{"field":"locked","values":[0]},
      alphaAllow:true,
      visibleWhen: [{"field":"extendedInfoTagMode","value":"text"},{"field":"type","value":"content"},{ "field": "typeTagName", "notValue": "Logo", "allowUndefined": true }]
    },
    {
      attributeName: 'extendedInfoBkColor',
      type: FormInputTypes.COLOR_PICKER,
      label: 'Background Color',
      helpText: 'Background color of the tag',
      enabledWhen:{"field":"locked","values":[0]},
      alphaAllow:true,
      visibleWhen: [{"field":"extendedInfoTagMode","value":"text"},{"field":"type","value":"content"},{ "field": "typeTagName", "notValue": "Logo", "allowUndefined": true }]

    },
    {
      attributeName: 'extendedInfoVisible',
      helpText: 'This checkbox is for the display of the tag on Extended Info. If it is set to false, it will not appear on that representation.',
      type: FormInputTypes.CHECKBOX,
      label: 'Visible',
      // default: true,
      enabledWhen:{"field":"locked","values":[0]},
      visibleWhen:{"field":"type","value":"content"}

    },
    {
      attributeName: 'infoWhenRoom',
      helpText: 'Extended Info view is not available in rooms.',
      type: FormInputTypes.TEXT,
      label: 'Extended Info view is not available in rooms',
      visibleWhen:{"field":"type","value":"room"}
    },
  ],
};
